// ManufacturingRawMaterialReducer.js — Manufacturing tab > Raw Material
// page. Wired into rootReducer.js as `manufacturingRawMaterials`.

const initialState = {
  rawMaterials: [],
  usageHistory: [],
  usageHistoryLoading: false,
  loading: false,
  actionLoading: false,
  error: null
};

const ManufacturingRawMaterialReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_RAW_MATERIALS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_RAW_MATERIALS_SUCCESS':
      return { ...state, loading: false, rawMaterials: action.payload, error: null };
    case 'FETCH_RAW_MATERIALS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'FETCH_RAW_MATERIAL_USAGE_REQUEST':
      return { ...state, usageHistoryLoading: true };
    case 'FETCH_RAW_MATERIAL_USAGE_SUCCESS':
      return { ...state, usageHistoryLoading: false, usageHistory: action.payload };
    case 'FETCH_RAW_MATERIAL_USAGE_FAILURE':
      return { ...state, usageHistoryLoading: false, error: action.payload };

    case 'CREATE_RAW_MATERIAL_REQUEST':
    case 'UPDATE_RAW_MATERIAL_REQUEST':
    case 'DELETE_RAW_MATERIAL_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'CREATE_RAW_MATERIAL_SUCCESS':
      return { ...state, actionLoading: false, rawMaterials: [action.payload, ...state.rawMaterials] };
    case 'UPDATE_RAW_MATERIAL_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        rawMaterials: state.rawMaterials.map((r) => (r.id === action.payload?.id ? { ...r, ...action.payload } : r))
      };
    case 'DELETE_RAW_MATERIAL_SUCCESS':
      return { ...state, actionLoading: false, rawMaterials: state.rawMaterials.filter((r) => r.id !== action.payload) };

    case 'CREATE_RAW_MATERIAL_FAILURE':
    case 'UPDATE_RAW_MATERIAL_FAILURE':
    case 'DELETE_RAW_MATERIAL_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default ManufacturingRawMaterialReducer;
